export default {"src":"/_next/static/media/gamingLogo4.edc5ba44.svg","height":20,"width":158,"blurWidth":0,"blurHeight":0};